import React from "react";
import numberToWord from "../../components/common/utlity/invoiceword";
import {
  SaleformatDateByBusinessPreference,
  truncateCommaSeparatedString,
} from "../../components/common/utlity/utility";
import { useTranslation } from "react-i18next";
import { AWS_URL } from "../../services/http.service";
import { Country, State } from "country-state-city";
const GstTheme3 = ({
  item,
  containerRef,
  businessName,
  phone,
  selectedColor,
  bussiness,
  darkMode = false,
}) => {
  const { t } = useTranslation();
  if (!item) return <div>No invoice data available</div>;
  // Format saleDate safely
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (isNaN(date)) return dateStr;
    return date.toLocaleDateString();
  };

  // Calculate totals
  const totalQuantity =
    (item?.invoiceId?.startsWith("RT")
      ? item?.returnitems
      : item?.items
    )?.reduce((sum, i) => sum + i.quantity, 0) || 0;
  const totalTaxable =
    (item?.invoiceId?.startsWith("RT")
      ? item?.returnitems
      : item?.items
    )?.reduce((sum, i) => sum + i.salePrice * i.quantity, 0) || 0;
  const totalAmount =
    (item?.invoiceId?.startsWith("RT")
      ? item?.returnitems
      : item?.items
    )?.reduce((sum, i) => sum + (i.finalPrice || 0), 0) || 0;

  const amountInWords = numberToWord(totalAmount || 0);

  const firstItem = (item?.items || item?.returnitems || [])[0] || {};
  const cgstRate = firstItem.cgst || 0;
  const sgstRate = firstItem.sgst_utgst || 0;
  const igstRate = firstItem.igst || 0;
  const cessRate = firstItem.cess || 0;

  // Group tax by IGST rate (assuming igst only as per your example)
  const taxGroups = {};
  (item?.invoiceId?.startsWith("RT")
    ? item?.returnitems
    : item?.items
  )?.forEach((itm) => {
    const rate = itm.igst || 0;
    if (!taxGroups[rate]) {
      taxGroups[rate] = { taxableAmount: 0, taxAmount: 0, rate };
    }
    taxGroups[rate].taxableAmount += itm.salePrice * itm.quantity;
    taxGroups[rate].taxAmount += (itm.salePrice * itm.quantity * rate) / 100;
  });

  const themeStyles = {
    background: "#eff6ff",
    textPrimary: "#000000",
    textSecondary:"#4a5568",
    border:  "#000000",
    tableHeader:"#cb39db",
    textColor:"#000000",
  };

  const businessCountry = bussiness?.country
    ? Country.getCountryByCode(bussiness.country)
    : null;
  const businessState = bussiness?.state
    ? State.getStateByCodeAndCountry(bussiness.state, bussiness.country)
    : null;

  const customerCountry = item?.country
    ? Country.getCountryByCode(item.country)
    : null;
  const customerState = item?.state
    ? State.getStateByCodeAndCountry(item.state, item.country)
    : null;

  return (
    <div
      className="w-full"
      ref={containerRef}
      style={{
        backgroundColor: themeStyles.background,
        color: themeStyles.textColor,
      }}
    >
      <p className="text-center font-bold">{t("NEWINVOICE.TAX_INVOICE")}</p>
      <div
        className="text-xl mb-4 border-2"
        style={{ border: "2px solid gray" }}
      >
        <div className="flex items-center justify-center gap-2">
          {/* Logo */}
          <span className="w-10 h-10 rounded-full overflow-hidden flex items-center justify-center bg-gray-100 shadow">
            <img
              src={
                AWS_URL + bussiness?.businesslogo ||
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
              }
              alt="Logo"
              className="w-full h-full object-contain"
              //crossOrigin="anonymous"
            />
          </span>

          <div>
            <p className="text-2xl font-bold">{businessName}</p>
            <p className="text-sm">
              {typeof bussiness?.address === "object"
                ? [bussiness?.address?.firstLine, bussiness?.address?.city, bussiness?.address?.state]
                    .filter(Boolean)
                    .join(", ")
                : bussiness?.address || "N/A"}
            </p>
            <p className="text-sm">Email: {bussiness?.email || "N/A"}</p>
            <p className="text-sm">GST No: {bussiness?.gstNumber || "N/A"}</p>
            <p className="text-sm">
              {t("NEWINVOICE.PHONE")}: {phone || "0000000000"}
            </p>
            <p className="text-sm text-center">
              {bussiness?.firstLine
                ? `${bussiness.firstLine}, ${businessState?.name || ""}, ${
                    businessCountry?.name || ""
                  }`
                : "N/A"}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2">
          {/* Bill To */}
          <div className="col-span-1" style={{ borderRight: "2px solid gray" }}>
            <div className={`font-calibri text-sm  font-bold ${selectedColor}`}>
              {t("NEWINVOICE.BILL_TO")}
            </div>
            <div className="font-calibri text-sm">
              {item.customerName || "-"}
            </div>
            <div className="text-sm">{item.mobile || "-"}</div>
            <div className="text-sm">
              {" "}
              {item?.address
                ? `${item.address}, ${customerState?.name || ""}, ${
                    customerCountry?.name || ""
                  }`
                : "N/A"}
            </div>
          </div>
          {/* Invoice Details */}
          <div className="col-span-1 text-right">
            <div className={`font-calibri ${selectedColor} text-sm font-bold`}>
              {t("NEWINVOICE.INVOICE_DETAILS")}
            </div>
            <div className="font-calibri text-sm">
              {t("NEWINVOICE.NO")}: {item.invoiceId || "-"}
            </div>
            {/* <div className='font-calibri text-sm ml-12'>
              Date: {formatDate(item.saleDate)}
            </div> */}
            <div className="font-calibri text-sm ml-12">
              {t("NEWINVOICE.DATE")}:{" "}
              {SaleformatDateByBusinessPreference(
                item?.saleDate,
                bussiness?.dateFormat
              )}
            </div>
          </div>
        </div>

        {/* Items Table */}
        <table className="border border-black w-full">
          <tbody>
            <tr className={`text-sm ${selectedColor}`}>
              <th style={{ width: "5%", borderRight: "2px solid black" }}>#</th>
              <th style={{ width: "25%", borderRight: "2px solid black" }}>
                {t("NEWINVOICE.ITEM_NAME")}
              </th>
              <th style={{ width: "10%", borderRight: "2px solid black" }}>
                {t("NEWINVOICE.HSN_SAC")}
              </th>
              <th style={{ width: "7%", borderRight: "2px solid black" }}>
                {t("NEWINVOICE.QTY")}
              </th>
              <th style={{ width: "15%", borderRight: "2px solid black" }}>
                {t("NEWINVOICE.PRICE_PER_UNIT")}
              </th>
              <th style={{ width: "17%", borderRight: "2px solid black" }}>
                {t("NEWINVOICE.TAXABLE_AMOUNT")}
              </th>
              <th style={{ width: "10%", borderRight: "2px solid black" }}>
                {t("NEWINVOICE.IGST")}
              </th>
              <th style={{ width: "10%", borderRight: "2px solid black" }}>
                {t("NEWINVOICE.AMOUNT")}
              </th>
            </tr>
            {(item?.invoiceId?.startsWith("RT")
              ? item?.returnitems
              : item?.items
            )?.map((itm, index) => (
              <tr key={index}>
                <td className="border border-black text-sm">{index + 1}</td>
                <td className="border border-black text-sm">
                  {itm.productName}
                </td>
                <td className="border border-black text-sm">
                  {truncateCommaSeparatedString(itm.hsnNumber) || "N/A"}
                </td>
                <td className="border border-black text-sm">{itm.quantity}</td>
                <td className="border border-black text-sm">
                  ₹ {itm.salePrice}
                </td>
                <td className="border border-black text-sm">
                  ₹ {(itm.salePrice * itm.quantity).toFixed(2)}
                </td>
                <td className="border border-black text-sm">{itm.igst}%</td>
                <td className="border border-black text-sm">
                  ₹ {itm.finalPrice || 0}
                </td>
              </tr>
            ))}
            {/* Optional subtotal row */}
            <tr className="font-bold">
              <td
                colSpan={3}
                className="border border-black text-sm text-center"
              >
                {t("NEWINVOICE.TOTAL")}
              </td>
              <td className="border border-black text-sm text-center">
                {totalQuantity}
              </td>
              <td className="border border-black" />
              <td className="border border-black text-sm">
                ₹ {totalTaxable.toFixed(2)}
              </td>
              <td className="border border-black" />
              <td className="border border-black text-sm">
                ₹ {item.transactionAmount }
              </td>
            </tr>
          </tbody>
        </table>

        {/* Taxes and other info */}
        <div className="grid grid-cols-2" style={{ border: "2px solid gray" }}>
          <div
            className="col-span-1 text-sm"
            style={{ borderRight: "2px solid gray", width: "100%" }}
          >
            <table className="border border-black w-full">
              <tbody>
                <tr className={`${selectedColor}`}>
                  <th className="border border-black w-1/4">
                    {" "}
                    {t("NEWINVOICE.TAX_TYPE")}
                  </th>
                  <th className="border border-black w-1/4">
                    {t("NEWINVOICE.TAXABLE_AMOUNT")}
                  </th>
                  <th className="border border-black w-1/4">
                    {" "}
                    {t("NEWINVOICE.RATE")}
                  </th>
                  <th className="border border-black w-1/4">
                    {" "}
                    {t("NEWINVOICE.TAX_AMOUNT")}
                  </th>
                </tr>

                {/* Tax rows */}
                {item.cgst > 0 && (
                  <tr>
                    <td className="border border-black p-2">{t("TAX_WITHOUT_PERC.CGST")}</td>
                    <td className="border border-black p-2">₹ {item.transactionAmount}</td>
                    <td className="border border-black p-2">{cgstRate}%</td>
                    <td className="border border-black p-2">₹ {parseFloat(item.cgst).toFixed(2)}</td>
                  </tr>
                )}
                {item.sgst > 0 && (
                  <tr>
                    <td className="border border-black p-2">{t("TAX_WITHOUT_PERC.SGST")}</td>
                    <td className="border border-black p-2">₹ {item.transactionAmount}</td>
                    <td className="border border-black p-2">{sgstRate}%</td>
                    <td className="border border-black p-2">₹ {parseFloat(item.sgst).toFixed(2)}</td>
                  </tr>
                )}
                {item.igst > 0 && (
                  <tr>
                    <td className="border border-black p-2">{t("TAX_WITHOUT_PERC.IGST")}</td>
                    <td className="border border-black p-2">₹ {item.transactionAmount}</td>
                    <td className="border border-black p-2">{igstRate}%</td>
                    <td className="border border-black p-2">₹ {parseFloat(item.igst).toFixed(2)}</td>
                  </tr>
                )}
                {item.cess > 0 && (
                  <tr>
                    <td className="border border-black p-2">{t("TAX_WITHOUT_PERC.CESS")}</td>
                    <td className="border border-black p-2">₹ {item.transactionAmount}</td>
                    <td className="border border-black p-2">{cessRate}%</td>
                    <td className="border border-black p-2">₹ {parseFloat(item.cess).toFixed(2)}</td>
                  </tr>
                )}

                <tr className={`${selectedColor}`}>
                  <th className="border border-black p-2" colSpan="4">
                    {t("NEWINVOICE.AMOUNT_IN_WORDS")}
                  </th>
                </tr>
                <tr>
                  <td className="border border-black p-2 w-full" colSpan="4">
                    {amountInWords} {t("NEWINVOICE.ONLY")}
                  </td>
                </tr>

                <tr className={`${selectedColor}`}>
                  <th className="border border-black p-2" colSpan="4">
                    {t("NEWINVOICE.PAYMENT_MODE")}
                  </th>
                </tr>
                <tr>
                  <td className="border border-black p-2 w-full" colSpan="4">
                    {item.paymentMode || "-"}
                  </td>
                </tr>

                <tr className={`${selectedColor}`}>
                  <th className="border border-black p-2" colSpan="4">
                    {t("NEWINVOICE.TERMS_CONDITIONS")}
                  </th>
                </tr>
                <tr>
                  <td className="border border-black p-2 w-full" colSpan="4">
                    {item.termsConditions || t("NEWINVOICE.THANKS_MESSAGE")}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Authorized signatory */}
          <div className="col-span-1 p-4">
            <table className="border border-black w-full">
              <tbody>
                <tr>
                  <td
                    className="border border-black p-2 text-right"
                    colSpan="2"
                  >
                    <div>
                      {" "}
                      {t("NEWINVOICE.FOR_COMPANY", { company: businessName })}
                    </div>
                    <div className="mt-6">
                      {" "}
                      {t("NEWINVOICE.AUTHORIZED_SIGNATORY")}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            {bussiness?.aadharPhoto && (
              <div class="flex  p-4 bg-gray-100 rounded-lg">
                <img
                  src={AWS_URL + bussiness?.aadharPhoto}
                  alt="Payment QR Code"
                  class="w-30 object-contain"
                  //crossOrigin="anonymous"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GstTheme3;
